import React, {Component} from 'react'
import './order-ticket.less'
import UserModal from './model'
import {toStrFixed} from '../../utills/subStringUtill'
import {
    reqArea, reqAddress, reqSaveTrack, reqUpdateTrack,
    getPackages, savePackage, updatePackage, delPackage, baseUrl, reqRentalBox,reqGetShiftList
}from'../../api'
import {
    Form, Input, Button, DatePicker, message, Select, Table, Popconfirm, Upload, Row, Col, Spin,
    Radio, Checkbox, Icon, Tooltip, Switch,
} from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
//import OrderFile from "./order-file";
//import DetailUploadTable from '../order-ticket/detail-upload-table'
import authorizePage from "../../components/authorize/authorizePage";
import authorizeBase from "../../components/authorize/authorizeBase";
import SelectAreaFormItem from '../track-edit/select-area'
import SelectBoxFormItem from '../track-edit/select-box'
import SelectShiftItem from '../track-edit/select-shift'
import {handleChangeArea, handleChangeRentalBox, handleChangePackageType, range, IconFont,handleChangeShift} from '../../utills/common';
//import { Router,Route } from 'react-router-dom'
const AuthButton = authorizeBase(Button)
const AuthFormItem = authorizeBase(Form.Item)
const AuthPopconfirm = authorizeBase(Popconfirm);
moment.locale('zh-cn');

const {Option} = Select;
const packageTypeStatus = {
    'packageTypeSmall' : '零售小包',
    'packageTypeNormal' : '本地一般贸易',
    'packageTypeNormalOut' : '外地一般贸易',
    'packageTypeDeclare' : '通关一体化',
    'packageTypeTransfer' : '转关运输',
    'packageTypeSale' : '寄售代销',
    'packageTypeB2b' :'B2B直接出口',
    'packageTypeOverseas' :'出口海外仓'
};
class OrderTicket extends Component {
    state = {
        previewVisible: false,
        previewImage: '',
        visible: false,
        countryData: [],
        stateData: [],
        cityData: [],
        deliveryEstimateDt: '', //提货时间
        countryDatas: [],
        stateDatas: [],
        cityDatas: [],
        consignorData: [],// 发货方地址
        notifyPartyData: [],// 通知方地址
        deliveryPlaceData: [],// 提货地址
        packageManageVos: [],  // 表格数据
        fileList: [],
        origin: [],
        destination: [],
        originCityId: '',
        destinationCityId: '',
        consigneeData: [],
        loading: false,
        intiCityValue: '赣州',
        intiCountryValue: '中国',
        rentBox: [],
        returnBox: [],
        shiftList:[],
        shiftDt:'',
        packageType1: false,
        packageType2: false,
        packageType3: false,
        packageType4: false,
        packageType: [],
        packageTypeStatus:''
    };
    showModal = () => {
        const {orderId} = this.state;
        if (orderId) {
            this.setState({
                visible: true,
                action: 'add',
            });
        } else {
            this.setState({loading: true});
            this.handleSaveSubmit(null, 'N')
        }

    };
    setInitAreaData = async (city, type) => {
        let result = await reqArea(type);
        if (result.code === 200) {
            let preInit;
            if (type === 'F') {
                preInit = city ? city : result.data[0].cityName;
                const record = handleChangeArea(this, 'originCity', preInit, 'originCountry', 'origin', result.data,'boxRentStation')
                this.setDefaultValue(record);
            } else if (type === 'T') {
                preInit = city ? city : result.data[0].cityName;
                const record = handleChangeArea(this, 'destinationCity', preInit, 'destinationCountry', 'destination', result.data,'boxReturnStation');
                this.setDefaultValue(record);
            } else if (type === 'D') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'internationalEndCity', preInit, 'internationalEndCountry', 'international', result.data);
                handleChangeArea(this, 'destinationStartCity', preInit, 'destinationStartCountry', 'international', result.data);
            }
        } else {
            message.error(result.message);
        }
    };
    //租箱地rent_box,还箱地return_box
    setInitRentalBoxData = async (stationValue, type) => {
        let result = await reqRentalBox(type);
        if (result.code === 200) {
            if (type === 'rent_box') {
                handleChangeRentalBox(this, 'boxRentStation', stationValue, 'rentBox', result.data)
            }
            else if (type === 'return_box') {
                handleChangeRentalBox(this, 'boxReturnStation', stationValue, 'returnBox', result.data);
            }
        } else {
            message.error(result.message);
        }
    };
    setDefaultValue = record => {
        if (Array.isArray(record[0].relDos) && record[0].relDos.length > 0) {
            record[0].relDos.map(o => {
                    //提货人
                    if (o.addressType == '3') {
                        this.handledeliveryPlaceChange(o.addressId);
                    }
                    //境外收货方
                    if (o.addressType == '6') {
                        this.consigneeHandleChange(o.addressId);
                    }
                    //通知方
                    if (o.addressType == '2') {
                        this.handlenotifyPartyChange(o.addressId);
                    }
                }
            );
        }
    };
// 获取地址信息
    getAddress = async (type) => {
        let result = await reqAddress(type)
        const res = result.data
        if (result.code === 200) {
            if (res.length > 0) {
                if (type === 3) {
                    this.setState({
                        deliveryPlaceData: res,
                    })
                } else if (type === 2) {
                    this.setState({
                        notifyPartyData: res,
                    })
                } else if (type === 1) {
                    this.setState({
                        consignorData: res,
                    });
                    if (result.data && result.data.length > 0) {
                        const o = result.data.filter(o => o.defalutFlag == 'Y')[0];
                        if (o) {
                            this.handleconsignorChange(o.id);
                        }
                    }
                } else if (type === 6) {
                    this.setState({
                        consigneeData: res,
                    })
                }
            }
        }
    };


    componentDidMount() {
        this.setInitAreaData('', 'F');
        this.setInitAreaData('', 'T');
        this.setInitAreaData('', 'D');
        this.setInitRentalBoxData(null, "rent_box");
        this.setInitRentalBoxData(null, "return_box");
        this.getAddress(3);
        this.getAddress(2);
        this.getAddress(1);
        this.getAddress(6);
        this.getShiftList();
    }
    //获取班次信息
    getShiftList = async () => {
        let result = await reqGetShiftList();
        if (result.code === 200) {
            this.setState({
                shiftList:result.data
            });
        } else {
            message.error(result.message);
        }
    };
    goods = async (orderId, page = 1, pageSize = 20) => {
        let result = await getPackages({orderId, pageNum: page, pageSize});
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    page,
                    pageSize,
                    total: result.data.total,
                    packageManageVos: result.data.rows,
                })
            }
        }
        else {
            message.error(result.message)
            return false;
        }
    };
    handleChange = info => {
        let fileList = [...info.fileList];
        fileList = fileList.map(file => {
            if (file.response) {
                if (file.response.code === 200) {
                    file.url = baseUrl + '/' + file.response.data.filePath;
                    file.id = file.response.data.id;
                } else {
                    file.status = 'error';
                    file.response = file.response.message;
                }
            }
            return file;
        });

        this.setState({fileList});
    };

    handleSaveSubmit = (e, isCommit) => {
        if (e) {
            e.preventDefault();
        }
        this.props.form.validateFieldsAndScroll((err, values) => {
            const {packageManageVos, deliveryEstimateDt, fileList} = this.state
            if (err) {
                message.error(err)
                this.setState({loading: false});
            } else {
                values.packageManagePos = packageManageVos;
                values.deliveryEstimateDt = deliveryEstimateDt;
                values.isCommit = isCommit;
                values.originCountry = this.state.originCountry;
                values.originEndCountry = this.state.intiCountryValue;
                values.internationalCountry = this.state.intiCountryValue;
                values.internationalEndCountry = this.state.internationalEndCountry;
                values.destinationStartCountry = this.state.destinationStartCountry;
                values.destinationCountry = this.state.destinationCountry;
                values.packageTypeNormal = this.state.packageTypeNormal;
                values.packageTypeNormalOut = this.state.packageTypeNormalOut;
                values.packageTypeSale = this.state.packageTypeSale;
                values.packageTypeSmall = this.state.packageTypeSmall;
                values.packageTypeDeclare = this.state.packageTypeDeclare;
                values.packageTypeTransfer = this.state.packageTypeTransfer;
                values.packageTypeB2b = this.state.packageTypeB2b;
                values.packageTypeOverseas = this.state.packageTypeOverseas;
                values.containerType = this.state.containerType;
                values.exportPort = this.state.exportPort;
                values.shiftDt = this.state.shiftDt;
                delete values.packageType;
                if (fileList && fileList.length > 0) {
                    let fileids = [];
                    fileList.forEach((item) => {
                        if (item.id) {
                            fileids.push(item.id);
                        }
                    });
                    values.fileIds = fileids;
                }
                if(values.boxRentStation===undefined){
                    values.boxRentStation=''
                }
                if(values.boxReturnStation===undefined){
                    values.boxReturnStation=''
                }
                this.saveTrackData(values, e, isCommit)
            }
        });
    }

    saveTrackData = async (data, e, isCommit) => {
        const {orderId} = this.state;
        if (orderId) {
            data.id = orderId;
            let result = await reqUpdateTrack(data)
            if (result.code === 200) {
                this.props.history.replace('/trackList')
            } else {
                message.error(result.message)
            }
        } else {
            let result = await reqSaveTrack(data)
            if (result.code === 201) {
              //  if (isCommit == 'Y') {
                    this.props.history.replace('/trackList')
                /*} else {
                    if (!e) {
                        this.showModal();
                    }
                    this.setState({orderId: result.data.id, orderNo: result.data.orderNo, loading: false})
                }*/
            } else {
                message.error(result.message)
            }
        }

    }
    getInformation = (o) => {
        const address = (o.country ? o.country : '') + (o.state ? o.state : '') + (o.city ? o.city : '') + o.address;
        const tel = [];
        if (o.phone) {
            tel.push(o.phone)
        }
        if (o.email) {
            tel.push(o.email)
        }
        return {
            address, tel
        }
    };

// 发货企业变化时
    handleconsignorChange = (key) => {
        const {consignorData} = this.state;
        consignorData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    shipper: o.company,
                    shipperAddr: address,
                    shipperContact: o.contact,
                    shipperTel: tel.toString()
                })
            }
        })
    };
    consigneeHandleChange = (addrId) => {
        const {consigneeData} = this.state;
        consigneeData.map(o => {
            if (o.id == addrId) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    consignee: o.company,
                    consigneeAddr: address,
                    consigneeContact: o.contact,
                    consigneeTel: tel.toString()
                })
                this.handleChangeSame(this.state.sameConsignee);
            }
        })
    };
// 通知方变化时
    handlenotifyPartyChange = (key) => {
        const {notifyPartyData} = this.state;
        notifyPartyData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    notifyParty: o.company,
                    notifyPartyAddr: address,
                    notifyPartyContact: o.contact,
                    notifyPartyTel: tel.toString()
                })
            }
        })
    };

// 提货方变化时
    handledeliveryPlaceChange = (key) => {
        const {deliveryPlaceData} = this.state;
        deliveryPlaceData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    deliveryPlace: address,
                    contact: o.contact,
                    contactTel: tel.toString()
                })
            }
        })
    };
//添加表格
    onOk = async (updateData) => {
        const {action, page, pageSize, orderId} = this.state;
        updateData.orderId = orderId;
        if (updateData.value !== undefined && updateData.pcsNumber !== undefined) {
            updateData.totalValue = toStrFixed(updateData.value * updateData.pcsNumber);
        }
        if (action === 'add') {
            let result = await savePackage(updateData);
            if (result.code == 201) {
                this.onCancel();
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        } else {
            let result = await updatePackage(updateData);
            if (result.code == 200) {
                this.onCancel();
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        }
    }

    onCancel = () => {
        this.setState({
            visible: false
        })
    }

// 日期选择

    onDateChange = (current, dateString) => {
        if (current) {
            //年月日
            const dateStart = moment().add('days', 0).startOf('day');
            if (current < dateStart) {
                current.add('days', 0);
                dateString = current.format('YYYY-MM-DD HH');
            }
            //小时
            const dateEnd = moment().add('days', 0).endOf('day');
            if (current < dateEnd) {
                const hour = new Date().getHours();
                if (current.hour() <= hour) {
                    current.hour(hour + 0);
                    dateString = current.format('YYYY-MM-DD HH');
                }
            }
        }
        //console.log(current, dateString)
        this.setState({
            deliveryEstimateDt: dateString
        })
    };

//显示弹窗
    editDataSource = (data) => {
        this.setState({
            visible: true,
            action: 'edit'
        })
        this.child.props.form.setFieldsValue(data);

    }

    handleDelete = async (id) => {
        let result = await delPackage(id, this.state.orderId);
        if (result.code == 200) {
            this.goods(this.state.orderId);
        } else {
            message.error(result.message);
        }
    };

    onRef = (ref) => {
        this.child = ref
    };

    disabledStartDate = (current) => {
        return current && current < moment().add('days', -1).endOf('day');
    };
    disabledDateTime = (current) => {
        if (current && current < moment().add('days', 0).endOf('day')) {
            const hour = new Date().getHours();
            return {
                disabledHours: () => range(0, hour + 0),
            };
        }
    };
    importChange = info => {
        let fileList = [...info.fileList];
        let complete = 0;
        fileList = fileList.map(file => {
            if (file.response) {
                // Component will show file.url as link
                if (file.response.code === 200) {
                    message.info(file.response.message);
                    this.goods(this.state.orderId);
                } else if (file.response.code === 205) {
                    message.error(file.response.message)
                    window.location.href = baseUrl + '/' + file.response.data;
                } else {
                    message.error(file.response.message)
                }
                file.status = 'done';
                complete = 1;
            }
            return file;
        });
        if (complete === 1) {
            this.setState({
                importList: []
            })
        } else {
            this.setState({importList: fileList});
        }
    };

    downloadModel = () => {
        window.location.href = baseUrl.replace('/oms', '/upload') + '/template/货物管理导入模板.xlsx';
    }
    search = e => {
        e.preventDefault();
        const {orderId, page, pageSize} = this.state;
        this.goods(orderId, page, pageSize);
    };
    handleChangeSame = (checked) => {
        if (checked) {
            const {consignee, consigneeAddr, consigneeContact, consigneeTel} = this.props.form.getFieldsValue();
            this.props.form.setFieldsValue({
                notifyParty: consignee,
                notifyPartyAddr: consigneeAddr,
                notifyPartyContact: consigneeContact,
                notifyPartyTel: consigneeTel
            })
        }
        this.setState({sameConsignee: checked})
    };

    render() {
        const uploadProps = {
            name: 'file',
            action: baseUrl + '/api/v1/p/oms/import',
            data: {orderId: this.state.orderId},
            withCredentials: true,
            onChange: this.importChange,
            fileList: this.state.importList,
            accept: ".xls,.xlsx,application/vnd.ms-excel",
        };

        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                md: {span: 9},
            },
            wrapperCol: {
                xs: {span: 24},
                md: {span: 14},
            },
        }
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                md: {
                    span: 24,
                    offset: 0,
                },
            },
        }

        const columns = [
            {
                title: '唛码标记Marks',
                dataIndex: 'boxNo',
                render: text => <a>{text}</a>,
            }, {
                title: '品名(中文)',
                dataIndex: 'name',
            }, {
                title: '品名(英文)',
                dataIndex: 'nameEn',
            }, {
                title: '国内HSCode',
                dataIndex: 'hscode',
            }, {
                title: '国外HSCode',
                dataIndex: 'oHscode',
            }, {
                title: '箱数CTNS',
                dataIndex: 'num',
            }, {
                title: '件数PCS',
                dataIndex: 'pcsNumber',
            }, {
                title: '毛重(Kg)',
                dataIndex: 'grossWeight',
            }, {
                title: '净重(Kg)',
                dataIndex: 'netWeight',
            }, {
                title: '体积(CBM)',
                dataIndex: 'volume',
            }, {
                title: '单价/币制Value unit',
                dataIndex: 'value',
                render: (text, record) => {
                    if (text && record.currency) {
                        return text + record.currency;
                    }
                }
            }, {
                title: '总价/币制Value & Currency',
                dataIndex: 'totalValue',
                render: (text, record) => {
                    if (record.value && record.pcsNumber) {
                        return toStrFixed(record.value * record.pcsNumber) + record.currency;
                    } else {
                        return ''
                    }
                }
            }, {
                title: '成分',
                dataIndex: 'ingredient',
            }, {
                title: '用途',
                dataIndex: 'application',
            }, {
                title: '操作',
                dataIndex: 'opt',
                width: 100,
                render: (text, record) => {
                    return (
                        <span> <a onClick={() => this.editDataSource(record)}
                                  style={{marginRight: 8}}>
                                        修改
                                    </a>
                            <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDelete(record.id)}>
                            <a>删除</a>
                        </Popconfirm>
                        </span>
                    );
                }
            }
        ];

        const {
            visible,
            consignorData,
            notifyPartyData,
            deliveryPlaceData,
            packageManageVos,
            updateKey
        } = this.state;
        return (
            <div className='order-ticket box-shadow'>
                <div className="head-title">
                    新建委托单
                </div>
                <div className="order-ticket-content">
                    <Spin spinning={this.state.loading}>
                        <Form {...formItemLayout} onSubmit={e => this.handleSaveSubmit(e, 'N')}>
                            <div className="order-spaceInfo-content">
                                <div className='content-head-title'>国内陆运</div>
                                <div className='spaceInfo-content-info'>
                                    <Row>
                                        <Col span={8}>
                                            <SelectAreaFormItem
                                                label='起运地'
                                                name="originCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.originCity}
                                                handleChange={e => {
                                                    const record = handleChangeArea(this, 'originCity', e, 'originCountry', 'origin',null,'boxRentStation');
                                                    this.setDefaultValue(record);
                                                }}
                                                disabledOpt={this.state.readOnly}
                                                data={[...this.state['origin']]}
                                            />
                                        </Col>
                                        <Col span={8}>
                                            <SelectAreaFormItem
                                                label='目的地'
                                                name="originEndCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.intiCityValue}
                                                disabledOpt={true}
                                                data={this.state.origin}
                                            />
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item>
                                                {getFieldDecorator('originDeliveryType', {
                                                    initialValue: this.state.originDeliveryType ? this.state.originDeliveryType : 'D',
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Radio.Group disabled={this.state.readOnly}>
                                                        <Radio value='D'>代运</Radio>
                                                        <Radio value='Z'>自运</Radio>
                                                        <Tooltip title="自运：由贵司承运；代运：由我司承运！">
                                                            <IconFont type="icon-wenhaow"/>
                                                        </Tooltip>
                                                    </Radio.Group>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='content-head-title'>国际铁路</div>
                                <div className='spaceInfo-content-info'>
                                    <Row>
                                        <Col span={8}>
                                            <SelectAreaFormItem
                                                label='起运地'
                                                name="internationalCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.intiCityValue}
                                                disabledOpt={true}
                                                data={this.state.origin}
                                            />
                                        </Col>
                                        <Col span={8}>
                                            <SelectAreaFormItem
                                                label='目的地'
                                                name="internationalEndCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.destinationStartCity}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.international}
                                                handleChange={e => {
                                                    handleChangeArea(this, 'internationalEndCity', e, 'internationalEndCountry', 'international');
                                                    handleChangeArea(this, 'destinationStartCity', e, 'destinationStartCountry', 'international');
                                                }}
                                            />
                                        </Col>
                                        <Col span={8}>
                                    <SelectShiftItem
                                        label='班次时间'
                                        name="shiftDt"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.shiftDt}
                                        disabledOpt={this.state.readOnly}
                                        data={this.state.shiftList}
                                        handleChange={e => {
                                            handleChangeShift(this, 'shiftDt', e, 'shiftList');
                                        }}
                                    />
                                </Col>
                                    </Row>
                                </div>
                                <div className='content-head-title'>欧洲公路/铁路转运</div>
                                <div className='spaceInfo-content-info'>
                                    <Row>
                                        <Col span={8}>
                                            <SelectAreaFormItem
                                                label='转关地'
                                                name="destinationStartCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.destinationStartCity}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.international}
                                                handleChange={e => {
                                                    handleChangeArea(this, 'internationalEndCity', e, 'internationalEndCountry', 'international')
                                                    handleChangeArea(this, 'destinationStartCity', e, 'destinationStartCountry', 'international')
                                                }}
                                            />
                                        </Col>
                                        <Col span={8}>
                                            <SelectAreaFormItem
                                                label='目的地'
                                                name="destinationCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.destinationCity}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.destination}
                                                handleChange={e => {
                                                    const record = handleChangeArea(this, 'destinationCity', e, 'destinationCountry', 'destination',null,'boxReturnStation');
                                                    this.setDefaultValue(record);
                                                }}
                                            />
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item>
                                                {getFieldDecorator('destinationDeliveryType', {
                                                    initialValue: this.state.destinationDeliveryType ? this.state.destinationDeliveryType : 'D',
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Radio.Group disabled={this.state.readOnly}>
                                                        <Radio value='D'>代运</Radio>
                                                        <Radio value='Z'>自运</Radio>
                                                        <Tooltip title="自运：由贵司承运；代运：由我司承运！">
                                                            <IconFont type="icon-wenhaow"/>
                                                        </Tooltip>
                                                    </Radio.Group>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="出境口岸">
                                                    {getFieldDecorator('exportPort', {
                                                        initialValue: this.state.exportPort,
                                                        rules: [{
                                                            required: true, 
                                                            message: '该项必填'
                                                        }],
                                                    })(<Select onChange={e => { this.setState({exportPort: e, change: true});}}>
                                                            <Option value='阿拉山口'>阿拉山口</Option>
                                                            <Option value='二连浩特'>二连浩特</Option>
                                                            <Option value='霍尔果斯'>霍尔果斯</Option>
                                                            <Option value='满洲里'>满洲里</Option>
                                                            <Option value='磨憨'>磨憨</Option>
                                                            <Option value='阿拉山口（马拉线）'>阿拉山口（马拉线）</Option>
                                                            <Option value='阿拉山口（乔普线）'>阿拉山口（乔普线）</Option>
                                                        </Select>)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='content-head-title'>其他信息</div>
                                <div className='spaceInfo-content-info'>
                                    <Row>
                                        <Col span={8}>
                                            <SelectBoxFormItem
                                                label='租箱地'
                                                name="boxRentStation"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.boxRentStation}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.rentBox}
                                                handleChange={e => {
                                                    handleChangeRentalBox(this, 'boxRentStation', e, 'rentBox')
                                                }}
                                            />
                                        </Col>
                                        <Col span={8}>
                                            <SelectBoxFormItem
                                                label='还箱地'
                                                name="boxReturnStation"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.boxReturnStation}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.returnBox}
                                                handleChange={e => {
                                                    handleChangeRentalBox(this, 'boxReturnStation', e, 'returnBox')
                                                }}
                                            />
                                        </Col>
                                     </Row>
                                    <Row>
                                        <Col span={8}>
                                            <Form.Item label="集装箱数">
                                                {getFieldDecorator('containerNum', {
                                                    initialValue: '1',
                                                    rules: [{
                                                        required: true,
                                                        message: '该项必填'
                                                    }, {
                                                        pattern: /^[1-9]\d*$/,
                                                        message: '必须为大于0的整数'
                                                    }]
                                                })(
                                                    <Input placeholder='集装箱数'  onChange={e => {
                                                        this.setState({containerNum: e.target.value})
                                                    }} readOnly={this.state.readOnly} disabled={true}/>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="集装箱类型">
                                                {getFieldDecorator('containerType', {
                                                    initialValue: '',
                                                    rules: [{
                                                        required: true, 
                                                        message: '该项必填'
                                                    }]
                                                })(<Select 
                                                    onChange={e => {
                                                    this.setState({containerType: e, change: true});
                                                }}>
                                                    <Option value='40HQ'>40HQ</Option>
                                                    <Option value='40GP'>40GP</Option>
                                                    <Option value='20GP'>20GP</Option>
                                                    <Option value='45GP'>45GP</Option>
                                                </Select>)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item label="货物类型" {...{
                                                labelCol: {span:3},
                                                wrapperCol: {span: 21}
                                            }}>
                                                {getFieldDecorator('packageTypeStatus', {
                                                initialValue: this.state.packageTypeStatus,
                                                rules: [{required: true, message: '该项必填'
                                                }],
                                            })(<Select
                                                onChange={e => handleChangePackageType(this, e)
                                                }>
                                                    <Option value='packageTypeSmall+packageTypeTransfer'>零售小包+转关运输</Option>
                                                    <Option value='packageTypeSmall+packageTypeDeclare'>零售小包+通关一体化</Option>
                                                    <Option value='packageTypeNormal+packageTypeSale'>本地一般贸易+寄售代销</Option>
                                                    <Option value='packageTypeNormal+packageTypeDeclare'>本地一般贸易+通关一体化</Option>
                                                    <Option value='packageTypeNormal+packageTypeTransfer'>本地一般贸易+转关运输</Option>
                                                    <Option value='packageTypeNormalOut+packageTypeSale'>外地一般贸易+寄售代销</Option>
                                                    <Option value='packageTypeNormalOut+packageTypeDeclare'>外地一般贸易+通关一体化</Option>
                                                    <Option value='packageTypeNormalOut+packageTypeTransfer'>外地一般贸易+转关运输</Option>
                                                    <Option value='packageTypeSale+packageTypeTransfer'>寄售代销+转关运输</Option>
                                                    <Option value='packageTypeSale+packageTypeDeclare'>寄售代销+通关一体化</Option>
                                                    <Option value='packageTypeB2b+packageTypeTransfer'>B2B直接出口+转关运输</Option>
                                                    <Option value='packageTypeB2b+packageTypeDeclare'>B2B直接出口+通关一体化</Option>
                                                    <Option value='packageTypeOverseas+packageTypeTransfer'>出口海外仓+转关运输</Option>
                                                    <Option value='packageTypeOverseas+packageTypeDeclare'>出口海外仓+通关一体化</Option>
                                                </Select>)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className='content-head-title'>发货企业信息</div>
                            <span><span>发货企业名称:</span></span>
                            <Select onChange={this.handleconsignorChange}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}>
                                {consignorData.map(country => (
                                    <Option key={country.id} value={country.id}>{country.company}</Option>
                                ))}
                            </Select>
                            <div className='spaceInfo-content-info' style={{width: '100%', marginTop: '10px'}}>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="发货企业名称">
                                            {getFieldDecorator('shipper', {
                                                initialValue: this.state.shipper,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(
                                                <Input placeholder="发货企业名称" onChange={e => {
                                                    this.setState({shipper: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="发货企业地址">
                                            {getFieldDecorator('shipperAddr', {
                                                initialValue: this.state.shipperAddr,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(
                                                <Input placeholder="发货企业地址" onChange={e => {
                                                    this.setState({shipperAddr: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="发货企业联系人">
                                            {getFieldDecorator('shipperContact', {
                                                initialValue: this.state.shipperContact,
                                            })(
                                                <Input placeholder="发货企业联系人" onChange={e => {
                                                    this.setState({shipperContact: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="发货企业联系方式">
                                            {getFieldDecorator('shipperTel', {
                                                initialValue: this.state.shipperTel,
                                            })(
                                                <Input placeholder="发货企业联系方式" onChange={e => {
                                                    this.setState({shipperTel: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            <div className='content-head-title'>境外收货方信息</div>
                            <div className="order-spaceInfo-content">
                                <span><span>境外收货方信息:</span></span>
                                <Select onChange={this.consigneeHandleChange}
                                        getPopupContainer={triggerNode => triggerNode.parentNode}
                                        disabled={this.state.readOnly}>
                                    {this.state.consigneeData.map(d => (
                                        <Option key={d.id} value={d.id}>{d.company}</Option>
                                    ))}
                                </Select>
                                <div className='spaceInfo-content-info'>
                                    <Row>
                                        <Col span={12}>
                                            <Form.Item label="境外收货方名称" {...formItemLayout}>
                                                {getFieldDecorator('consignee', {
                                                    initialValue: this.state.consignee,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input onChange={this.consigneeChange}
                                                          readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="境外收货方地址" {...formItemLayout}>
                                                {getFieldDecorator('consigneeAddr', {
                                                    initialValue: this.state.consigneeAddr,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input onChange={this.consigneeAddrChange}
                                                          readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="境外收货方联系人" {...formItemLayout}>
                                                {getFieldDecorator('consigneeContact', {
                                                    initialValue: this.state.consigneeContact,
                                                })(<Input onChange={this.consigneeContactChange}
                                                          readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="境外收货方联系方式" {...formItemLayout}>
                                                {getFieldDecorator('consigneeTel', {
                                                    initialValue: this.state.consigneeTel,
                                                })(<Input onChange={this.consigneeTelChange}
                                                          readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className='content-head-title'>
                                通知方信息<span style={{marginLeft: '10px'}}>
                        <Checkbox value="sameConsignee" disabled={this.state.readOnly}
                                  onChange={e => {
                                      this.handleChangeSame(e.target.checked)
                                  }}>同境外收货方</Checkbox></span></div>
                            <span><span>通知方名称:</span></span>
                            <Select onChange={this.handlenotifyPartyChange}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}>
                                {notifyPartyData.map(notify => (
                                    <Option key={notify.id} value={notify.id}>{notify.company}</Option>
                                ))}
                            </Select>
                            <div className='spaceInfo-content-info'>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="通知方名称" {...formItemLayout}>
                                            {getFieldDecorator('notifyParty', {
                                                initialValue: this.state.notifyParty,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(
                                                <Input placeholder="通知方名称" onChange={e => {
                                                    this.setState({notifyParty: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="通知方地址" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyAddr', {
                                                initialValue: this.state.notifyPartyAddr,
                                            })(
                                                <Input placeholder="通知方地址" onChange={e => {
                                                    this.setState({notifyPartyAddr: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="通知方联系人" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyContact', {
                                                initialValue: this.state.notifyPartyContact,
                                            })(
                                                <Input placeholder="通知方联系人" onChange={e => {
                                                    this.setState({notifyPartyContact: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="通知方联系方式" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyTel', {
                                                initialValue: this.state.notifyPartyTel,
                                            })(
                                                <Input placeholder="通知方联系方式" onChange={e => {
                                                    this.setState({notifyPartyTel: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            <div className='content-head-title'>仓库联系人信息</div>
                            <span><span>仓库联系人名称:</span></span>
                            <Select onChange={this.handledeliveryPlaceChange}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}>
                                {deliveryPlaceData.map(delivery => (
                                    <Option key={delivery.id} value={delivery.id}>{delivery.company}</Option>
                                ))}
                            </Select>
                            <div className='spaceInfo-content-info'>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="仓库地点" {...formItemLayout}>
                                            {getFieldDecorator('deliveryPlace', {
                                                initialValue: this.state.deliveryPlace,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(
                                                <Input placeholder="仓库地点" onChange={e => {
                                                    this.setState({deliveryPlace: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="预计提货时间" {...formItemLayout}>
                                            {getFieldDecorator('deliveryEstimateDt', {
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<DatePicker
                                                format="YYYY-MM-DD HH"
                                                onChange={this.onDateChange} style={{width: '100%'}}
                                                disabledDate={this.disabledStartDate}
                                                disabledTime={this.disabledDateTime}
                                                showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                                            />)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系人" {...formItemLayout}>
                                            {getFieldDecorator('contact', {
                                                initialValue: this.state.contact,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(
                                                <Input placeholder="仓库联系人" onChange={e => {
                                                    this.setState({contact: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系人方式" {...formItemLayout}>
                                            {getFieldDecorator('contactTel', {
                                                initialValue: this.state.contactTel,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(
                                                <Input placeholder="仓库联系人方式" onChange={e => {
                                                    this.setState({contactTel: e.target.value})
                                                }}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            {/* <div className='content-head-title'>附件信息</div>
                            <div className='spaceInfo-content-info'>
                                <Button key="/orderTicket/file" disabled={this.state.readOnly} type="primary">添加附件</Button>
                            </div>
                            <div>
                            <Switch>
                                <Route exact path="/orderTicket/file" Component={OrderFile}></Route>
                            </Switch>
                            </div> */}
                            <UserModal onOk={this.onOk}
                                       onRef={this.onRef}
                                       updateKey={ updateKey }
                                       visible={visible} onCancel={this.onCancel}/>
                            <div className='box-submit'>
                                <AuthFormItem authority="order_start:commit" {...tailFormItemLayout} >
                                    <Button type="primary" htmlType="submit"
                                            style={{marginRight: '10px'}}>保存</Button>
                                    <AuthPopconfirm title="是否确定保存并提交?" onConfirm={e => this.handleSaveSubmit(e, 'Y')}>
                                        <Button type='primary'>保存并提交</Button>
                                    </AuthPopconfirm>
                                </AuthFormItem>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div>
        )
    }
}

const
    WrapOrderTicket = authorizePage("order_start:commit")(Form.create()(OrderTicket))
export
default
WrapOrderTicket